module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00172.919c6ea9.jpg";